module.exports = __webpack_public_path__ + "img/e3cd263.jpg";